import { fromJS, Map } from 'immutable'
import { uploadDocument as uploadDocumentApi, deleteDocument as deleteDocumentApi } from 'tve/api/atp'

export const uploadDocument = (dataHandler) => (file, meta) => {
  const id = dataHandler.get('id')
  const uploader = uploadDocumentApi(id)

  const promise = uploader(file, meta).then(
    (fileInfo) => {
      const documents = dataHandler.get('documents')
      const newDocuments = documents.update(
        documents.findIndex((item) => {
          return item.get('id') == dummyFileInfo.get('id')
        }),
        () => fromJS(fileInfo).merge(Map({ isUploaded: true }))
      )
      dataHandler.set('documents', newDocuments)
    },
    (error) => {
      const documents = dataHandler.get('documents')
      const newDocuments = documents.update(
        documents.findIndex((item) => {
          return item.get('id') == dummyFileInfo.get('id')
        }),
        () =>
          dummyFileInfo.merge({
            error: error,
            isUploading: false
          })
      )
      dataHandler.set('documents', newDocuments)
    }
  )

  const dummyFileInfo = fromJS({
    ...meta,
    id: Math.random()
      .toString(36)
      .slice(2),
    filename: file.name,
    size: file.size,
    isUploading: true
  }).merge(Map({ promise }))

  dataHandler.update((data) => {
    return data.set('documents', data.get('documents').push(dummyFileInfo))
  })
  return promise
}

export const deleteDocument = (dataHandler) => (document) => {
  const leadId = dataHandler.get('id')
  const documentId = document.get('id')
  const doc = dataHandler.get('documents').find((doc) => doc.get('id') == documentId)
  if (doc) {
    return deleteDocumentApi(leadId, documentId).then(() => {
      const index = dataHandler.get('documents').indexOf(doc)
      dataHandler.update((data) => data.deleteIn(['documents', index]))
    })
  } else {
    return Promise.reject('document does not exist')
  }
}
